import { QuestionBase } from './question-base.model';

export class PasswordQuestion extends QuestionBase<string> {
   controlType = 'password';
   type: string;
   placeholder: string;
   maxlength: string;
   minlength: string;
   pattern: string;
   trim: boolean;
   disabled: boolean;
   changeEvent: boolean;
   controlToValidate: string;
   enable: boolean;
   visible: string;
   password_hint: boolean;

   constructor(options: {} = {}) {
      super(options);
      this.type = options['type'] || '';
      this.placeholder = options['placeholder'] || '';
      this.maxlength = options['maxlength'] || '';
      this.minlength = options['minlength'] || '';
      this.pattern = options['pattern'] || '';
      this.trim = options['trim'] || '';
      this.disabled = options['disabled'] || '';
      this.changeEvent = options['changeEvent'] || false;
      this.controlToValidate = options['controlToValidate'] || '';
      this.visible = (options['visible'] == undefined) ? true : options['visible'];
      this.password_hint = options['password_hint'] ? true : false;
      this.pattern = options['pattern'] || '';
   }
}